import {UserGlobalInfo} from "@/Core/Login/types/user";
import Util from "@/Master/Util";
import {DriveUtil} from "@/Master/DriveUtil";
import {RewardType} from "@/Core/Reward/RewardInfo";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import json from "@/app/config/game_core_config_1.json"

export default class UserMgr {
    public static dispatch: any;
    static defaultUserInfo: UserGlobalInfo = new UserGlobalInfo();

    //设置临时内存值。其他可以可以不用使用上下文获取
    private static tempUserInfo: UserGlobalInfo;

    static Init(dispatch: any) {
        this.dispatch = dispatch;

        //初始化默认数据
        this.tempUserInfo = Util.DeepClone(this.defaultUserInfo);
    }

    static get checkTempUserInfo(){
        const isTempDataOk = (this.tempUserInfo?.token);
        if (!isTempDataOk){
            console.error('not Temp UserInfo');
            return false;
        }
        return true;
    }

    //*
    // 获取数值配置
    // *
    static get getGameCoreConfig() {
        return json;
    }

    //*
    //获取用户信息
    //*
    static get getTempUserInfo() {
        if (!this.checkTempUserInfo) return this.defaultUserInfo;
        return this.tempUserInfo;
    }

    //*
    //获取用户基本信息
    //*
    static get getTempUserBaseInfo() {
        if (!this.checkTempUserInfo) return this.defaultUserInfo.baseInfo;
        return this.tempUserInfo.baseInfo;
    }

    static get gcCountAmount(){
        if (!this.checkTempUserInfo)return this.defaultUserInfo.baseInfo.gcAmount;
        return this.tempUserInfo.baseInfo.gcAmount;
    }

    static get gcCount() {
        return this.gcCountAmount;
    }

    static get scCountAmount(){
        if (!this.checkTempUserInfo) return 0;
        const baseInfo = this.tempUserInfo.baseInfo;
        return baseInfo.convertTotalScAmount;
    }

    static get scCount(){
        return  DriveUtil.ToNormalUnit(this.scCountAmount);
    }

    //退出登录时 需要充值上下文的所有数据
    static resetUpdateUser() {
        this.updateUser('resetUpdateUser',this.defaultUserInfo);
    }

    //设置当前的奖励类型
    static setRewardType(type: RewardType) {
        LoginUIManager.setLastUserRewardType(type);
        this.updateUser('setRewardType',{rewardType: type});
    }

    //*
    // 更新用户信息
    // Partial使 T 中的所有属性都成为可选的
    // *
    static updateUser(tag:string,updateData: Partial<UserGlobalInfo>) {
        this.dispatch({
            type: 'UPDATE_USER_INFO',
            tag:tag,
            payload: updateData,
        });
    }

    static userReducerUpdate(state: UserGlobalInfo, action: any) {
        let data = Util.DeepClone(state);
        if (Util.isLog) {
            console.group(`更新用户数据 ${action.tag}`)
            console.log(action.tag,'更新用户数据-开始', state, action);
        }
        switch (action.type) {
            //更新用户所有信息 可以组合默认使用原先的
            case 'UPDATE_USER_INFO':
                data = {
                    ...state,
                    ...action.payload
                };
                break;
        }

        const info = data.baseInfo;
        if (info && typeof info === 'object') {
            //SC
            info.scCountAtom = info.convertTotalScAmount;
            info.scCount = DriveUtil.ToNormalUnit(info.scCountAtom);

            //可兑换sc
            info.scAvailableToRedeemAtom = info.convertAvailableScAmount;
            info.scAvailableToRedeem = DriveUtil.ToNormalUnit(info.convertAvailableScAmount);

            //奖励sc
            info.scUnPlayedBalanceAtom = info.convertRewardScAmount;
            info.scUnPlayedBalance = DriveUtil.ToNormalUnit(info.convertRewardScAmount);

        }
        
        if (Util.isLog){
            console.log(action.tag,'更新用户数据-更新完成', data);
            console.groupEnd();
            if (!data.token){
                console.error(action.tag,'更新用户数据-token错误-检查更新前的数据', data);
            }
        }

        //设置临时内存值。其他可以可以不用使用上下文获取
        UserMgr.tempUserInfo = data;

        return data;
    }

    static hasTokenOk(token:string){
        if (!(token)){
            return false;
        }
        if (token.length <= 0){
            return false;
        }
        if (this.isTokenExpired){
            return false;
        }
        return true;
    }

    //本地储存的token是否过期
    static get isTokenExpired(): boolean {
        let tokenTime = LoginUIManager.getLastUserTokenTime;

        //默认0就是没有过期
        if (tokenTime <= 0) return false;
        if (tokenTime <= 3000) return false;
        const timeStamp = Util.localTimeStampMill;
        const isExpired = timeStamp >= tokenTime
        if (Util.isLog){
            if (isExpired){
                console.error('Token Expired')
            }
        }
        return isExpired;
    }

    //是否已经登陆过帐号
    static get isSignUpOK(): boolean {
        //token过期 也不算登陆成功
        if (this.isTokenExpired) return false;

        const account = LoginUIManager.getLastUserAccount;
        const token = LoginUIManager.getLastUserToken;
        const userId = LoginUIManager.getLastUserId;
        if (account && userId && token) {
            return true;
        }
        return false;
    }

}


